// extracted by mini-css-extract-plugin
export var errorIcon = "_nj-1";
export var nameLogo = "_nj-0";